module.exports = __webpack_public_path__ + "static/media/shape_3.3edca152.png";